var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcHail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.22,33.88a8,8,0,0,0-10.47-7.63,10.23,10.23,0,0,0-20.4,1,10.85,10.85,0,0,0,.2,2h-1.9a6.32,6.32,0,0,0,0,12.63H49.91a6.3,6.3,0,0,0,4.67-2.08A8,8,0,0,0,57.22,33.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.57,
    y: 45.22,
    width: 3.79,
    height: 3.79,
    transform: "translate(12.71 -5.87) rotate(14.47)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.35,
    y: 51.41,
    width: 3.79,
    height: 3.79,
    transform: "translate(-8.85 7.25) rotate(-10.18)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.37,
    y: 46.24,
    width: 3.79,
    height: 3.79,
    transform: "translate(44.25 -16.58) rotate(42.82)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.36,
    y: 58.77,
    width: 3.79,
    height: 3.79,
    transform: "translate(21.25 -7.47) rotate(18.73)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.33,
    y: 53.31,
    width: 3.79,
    height: 3.79,
    transform: "translate(-17.26 22.79) rotate(-22.29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHail);
export default __webpack_public_path__ + "static/media/dc_hail.1db2fa3e60bfa90246442848375d07ff.svg";
export { ForwardRef as ReactComponent };